import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Fallback token for environments where the httpOnly cookie is blocked
// (e.g. Safari/Brave inside the preview iframe). Cookie stays the primary auth.
export const setAuthToken = (token) => {
  try {
    if (token) localStorage.setItem("pgm_token", token);
    else localStorage.removeItem("pgm_token");
  } catch (e) { console.warn("Token storage unavailable:", e); }
};

api.interceptors.request.use((config) => {
  try {
    const token = localStorage.getItem("pgm_token");
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch (e) { console.warn("Token read failed:", e); }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      try {
        localStorage.removeItem("pgm_user");
        localStorage.removeItem("pgm_token");
      } catch (e) { console.warn("Token cleanup failed:", e); }
      if (typeof window !== "undefined" && window.location.pathname !== "/login" && window.location.pathname !== "/") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);
